<template>
  <div class="order s-new-theme">
    <div class="order-task">
      <div
        v-for="(item, index) in taskList"
        :key="index"
        class="task-one"
        :class="item.process ? 'finished' : index === 2 ? 'ing' : ''"
      >
        {{ index + 1 }}.{{ item.name }}
        <div class="box">
          <div v-if="!item.process"></div>
          <i v-else class="icon iconfont icon-duigou" style="color: #fff"></i>
        </div>
      </div>
      <!-- <div class="task-one">
        完成
        <div class="box"><div></div></div>
      </div> -->
      <div class="line"></div>
    </div>
    <div class="order-header">
      <p>参展申请</p>
      <span></span>
      <p>选择订单</p>
    </div>

    <!-- 展区 -->
    <div class="order-exhall">
      <p class="exhall-header" v-if="orderInfo && orderInfo.isAgent === '否'">
        请选择您要参展的展区
      </p>
      <p class="exhall-header" v-if="orderInfo && orderInfo.isAgent === '是'">
        请选择组团
      </p>
      <div class="exhall-list">
        <template v-if="list && list.length > 0">
          <div
            class="list-one"
            v-for="(item, index) in list"
            v-if="item.languageType == '中文' && item.isEnable"
            :key="index"
            @click="select(item)"
            :class="
              selectedExhall && selectedExhall.id === item.id ? 'selected' : ''
            "
          >
            {{ item.name }}
          </div>
          <Input
            v-model="remark"
            placeholder="请输入产品类型"
            v-if="inputShow"
            style="width: 300px"
          />
        </template>
        <div v-else style="width: 100%; line-height: 200px; text-align: center">
          暂无数据！
        </div>
      </div>
      <p class="exhall-header" v-if="orderInfo && orderInfo.isAgent === '否'">
        请选择展位类型
      </p>
      <p class="exhall-header" v-if="orderInfo && orderInfo.isAgent === '是'">
        请选择组团类型
      </p>

      <!-- 请选择展位类型 商品信息 -->
      <div class="booth-list">
        <template v-if="boothList && boothList.length &&selectedExhall">
          <div
            class="booth-one"
            :class="
              chooseBooth && chooseBooth.id === item.id ? 'chooseboothOne' : ''
            "
            v-for="(item, index) in boothList"
            :key="index"
            v-if="item.isEnable"
            @click="choose(item)"
          >
            <div class="f">
              <p :title="item.name">{{ item.name }}</p>
              <p :title="item.remark">{{ item.remark }}</p>
            </div>
            <div>
              <p
                v-if="item.remarkList && item.remarkList.length > 1"
                style="color: red"
              >
                {{ item.remarkList[1] }}
              </p>
            </div>
            <!-- 商品价格 -->
            <div class="s">
              <!-- <p>媒体推广费 RMB 3400.00</p> -->
              <p></p>
              <p v-if="orderInfo && orderInfo.isAgent === '否'">
                {{ item.price }}{{ item.currencyKind }}/{{ item.unit }}
              </p>
            </div>
            <div class="t">
              面宽：<InputNumber
                :max="999999999"
                :min="0"
                v-model="item.width1"
                @on-change="(v) => changeWidth1(v, index)"
              >
              </InputNumber>
              × 进深：<InputNumber
                :max="999999999"
                :min="0"
                v-model="item.width2"
                @on-change="(v) => changeWidth2(v, index)"
                >>
              </InputNumber>
              = {{ item.width1 * item.width2 }} ㎡
            </div>
            <div class="l">
              <!-- <span
                v-if="
                  item.boothArea > 1 &&
                  (item.unit.indexOf('㎡') != -1 ||
                    item.unit.indexOf('平米') != -1 ||
                    item.unit.indexOf('平方米') != -1 ||
                    item.unit.indexOf('m²') != -1 ||
                    item.unit.indexOf('sqm') != -1)
                "
                >合计：{{
                  (
                    (item.width1 * item.width2 * item.price) /
                    item.boothArea
                  ).toFixed()
                }}{{ item.currencyKind }}</span
              > -->
              <span v-if="item.boothArea > 1"
                >合计：{{
                  (
                    (item.width1 * item.width2 * item.price) /
                    item.boothArea
                  ).toFixed()
                }}{{ item.currencyKind }}</span
              >
              <span v-else
                >合计：{{ item.width1 * item.width2 * item.price }}
                {{ item.currencyKind }}</span
              >
            </div>
            <div
              class="choose"
              :class="
                chooseBooth && chooseBooth.id === item.id ? 'choosed' : ''
              "
            >
              <i class="icon iconfont icon-duigou"></i>
            </div>
          </div>
        </template>
        <div v-else style="width: 100%; line-height: 200px; text-align: center">
          暂无数据！
        </div>
      </div>
    </div>

    <div class="order-other">
      <p class="other-header" style="margin-bottom: 30px">固定费用</p>

      <template v-if="fixedCostList && fixedCostList.length > 0">
        <!-- <div
          class="other-list"
          v-for="(item, index) in fixedCostList"
          :key="'other' + index"
          v-if="item.groupLanguage === '中文' && item.isEnable"
        > -->
        <div class="other-list">
          <template>
            <div class="content" v-if="fixedCostList.length > 0">
              <div
                class="content-one chooseboothOne"
                v-for="(itm, idx) in fixedCostList"
                v-if="itm.groupLanguage === '中文' && itm.isEnable"
                :key="idx"
              >
                <div class="title">{{ itm.name }}</div>
                <div class="details">
                  <div class="text">
                    <div class="time"></div>
                    <div class="time" v-if="orderInfo">
                      <span>单价</span>
                      <p
                        style="
                          padding: 5px 0;
                          background: #fff;
                          color: #db2a4b;
                          font-size: 14px;
                        "
                      >
                        {{ itm.price }}{{ itm.currencyKind }}/{{ itm.unit }}
                      </p>
                    </div>
                    <div class="time">
                      <span>个数</span>
                      <InputNumber
                        @click.stop.native
                        style="width: 100px"
                        :max="9999999999"
                        @on-change="changeNumber(itm, $event)"
                        :min="0"
                        v-model="itm.cunit"
                        :disabled="true"
                      >
                      </InputNumber
                      >&nbsp;&nbsp;&nbsp;{{ itm.unit }}
                    </div>
                    <p style="margin-top: 30px" v-if="orderInfo">
                      总价: {{ itm.price }} {{ itm.currencyKind }}
                    </p>
                    <div class="choose choosed">
                      <i class="icon iconfont icon-duigou"></i>
                    </div>
                  </div>

                  <img v-if="itm.netImg" :src="itm.netImg" />
                </div>
              </div>
            </div>
            <div
              v-else
              style="width: 100%; line-height: 200px; text-align: center"
            >
              暂无数据！
            </div>
          </template>
        </div>
      </template>
      <div v-else style="width: 100%; line-height: 200px; text-align: center">
        暂无数据！
      </div>
    </div>
    <!-- 请选择线上/线下市场增值服务项目 -->
    <div class="order-other" :key="componentKey">
      <p class="other-header" style="margin-bottom: 30px">
        请选择线上/线下市场增值服务项目<span style="color: #db2a4b"
          >（根据需求选择意向合作的内容，我们会联系您）</span
        >
      </p>
      <!-- <div class="other-online" v-if="onlineFile && onlineFile.downloadLink">
                线上赞助项目：
                <a :href="onlineFile.downloadLink" download target="_blank">点击下载线上市场增值服务详情文件</a>
            </div> -->
      <template v-if="onlineOfflineCostList.length > 0">
        <div
          class="other-list"
          v-for="(item, index) in onlineOfflineCostList"
          v-if="item.groupLanguage === '中文' && item.isEnable"
          :key="'other' + index"
        >
          <div class="top">
            <div class="l">
              <Checkbox
                size="large"
                @on-change="allChoose(item, $event)"
                v-model="item.isCheck"
              >
              </Checkbox>
              {{ item.groupName }}
            </div>
            <div
              class="r"
              v-if="!item.isPack && onlineOfflineCostList.length > 0"
              @click="(item.isPack = !item.isPack), componentKey++"
            >
              展开
              <i
                class="icon iconfont icon-expanding"
                style="transform: rotate(90deg)"
              ></i>
            </div>
            <div
              class="r"
              v-else-if="onlineOfflineCostList.length > 0"
              @click="(item.isPack = !item.isPack), componentKey++"
            >
              收起
              <i
                class="icon iconfont icon-expanding"
                style="transform: rotate(-90deg)"
              ></i>
            </div>
          </div>
          <template v-if="onlineOfflineCostList.length > 0 && item.isPack">
            <div class="content" v-if="onlineOfflineCostList.length > 0">
              <div class="content-one">
                <div class="title">{{ item.name }}</div>
                <div class="details">
                  <div class="text" @click="chooseOne(item, index)">
                    <div class="time" v-if="orderInfo">
                      <span>价格</span>
                      <p
                        style="
                          padding: 5px 0;
                          background: #fff;
                          color: #db2a4b;
                          font-size: 14px;
                        "
                      >
                        {{ item.price }}{{ item.currencyKind }}/{{ item.unit }}
                      </p>
                    </div>
                    <div class="time">
                      <span>订购数量</span>
                      <InputNumber
                        @click.stop.native
                        style="width: 100px"
                        :max="9999999999"
                        @on-change="changeNumber(item, $event)"
                        :min="0"
                        v-model="item.orderNum"
                      >
                      </InputNumber>
                      &nbsp;&nbsp;&nbsp;{{ item.unit }}
                    </div>
                    <p style="margin-top: 30px" v-if="orderInfo">
                      合计:
                      {{ item.orderNum * item.price }}
                      {{ item.currencyKind }}
                    </p>
                    <div class="choose" :class="item.isCheck ? 'choosed' : ''">
                      <i class="icon iconfont icon-duigou"></i>
                    </div>
                  </div>

                  <img v-if="item.netImg" :src="item.netImg" />
                </div>
              </div>
            </div>
            <div
              v-else
              style="width: 100%; line-height: 200px; text-align: center"
            >
              暂无数据！
            </div>
          </template>
        </div>
      </template>
      <div v-else style="width: 100%; line-height: 200px; text-align: center">
        暂无数据！
      </div>
      <div class="total">
        <p>
          线上线下市场增值服务订单小计： <span>{{ otherTotalPrice }}</span>
          {{ currency }}
        </p>
        <p style="margin-top: 20px">
          展位订单小计：
          <span>
            <template v-if="chooseBooth">{{
              chooseBooth.boothArea > 1
                ? (
                    (chooseBooth.width1 *
                      chooseBooth.width2 *
                      chooseBooth.price) /
                    chooseBooth.boothArea
                  ).toFixed()
                : chooseBooth.width1 * chooseBooth.width2 * chooseBooth.price
            }}</template>
            <template v-else>0</template>
          </span>
          元
        </p>
        <p style="margin-top: 20px">
          固定费用: <span>{{ fixedpriceAdd }}</span
          >元
        </p>
        <p style="margin-top: 20px">
          订单合计：
          <span style="font-size: 20px; font-weight: bold">
            <template v-if="chooseBooth">{{
              Number(
                (
                  (this.chooseBooth.width1 *
                    this.chooseBooth.width2 *
                    this.chooseBooth.price) /
                  parseInt(this.chooseBooth.boothArea)
                ).toFixed()
              ) +
              fixedpriceAdd +
              otherTotalPrice
            }}</template>
            <template v-else>{{ fixedpriceAdd + otherTotalPrice }}</template>
          </span>
          元
        </p>
      </div>
    </div>

    <div class="order-btn">
      <Button
        type="primary"
        class="s-btn-red"
        size="large"
        @click="goBack"
        style="margin-right: 30px"
        >上一步</Button
      >
      <Button
        type="primary"
        class="s-btn-red"
        size="large"
        @click="goNext"
        :loading="loading"
        >保存并下一步</Button
      >
    </div>

    <iModal
      cancel-text
      title=""
      width="416"
      v-model="isChange"
      :closable="false"
      :footer-hide="true"
    >
      <div class="change-modal">
        <div class="change-modal-top">
          <Icon type="ios-alert" color="#f90" size="28" />
          <p>确认</p>
        </div>
        <div class="change-modal-bottom">
          <p v-if="chooseBooth">
            您确定要放弃订购{{ chooseBooth.name }}展位吗 ？
          </p>
        </div>
        <div class="change-modal-btn">
          <Button
            type="text"
            @click="
              isChange = false;
              middleInfo = null;
            "
            >取消</Button
          >
          <Button type="primary" @click="confirm()" style="margin-left: 10px"
            >确定</Button
          >
        </div>
      </div>
    </iModal>

    <iModal
      cancel-text
      title=""
      width="416"
      v-model="errorMsgBool"
      :mask-closable="false"
      :closable="false"
      :footer-hide="true"
    >
      <div class="change-modal">
        <div class="change-modal-top">
          <Icon type="ios-alert" color="red" size="28" />
          <p>确认</p>
        </div>
        <div class="change-modal-bottom">
          <p>{{ msgErrors }}</p>
        </div>
        <div class="change-modal-btn">
          <!-- <Button type="text" @click="isChange=false;middleInfo=null;">取消</Button> -->
          <Button type="primary" @click="goBack()" style="margin-left: 10px"
            >确定</Button
          >
        </div>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
let moment = require("moment");

export default {
  name: "order",
  data() {
    return {
      msgErrors: "",
      errorMsgBool: false,
      currency: "",
      taskList: [],
      speenInfo: null,
      loading: false,
      list: [],
      boothList: [],
      selectedExhall: null,
      chooseBooth: null,
      otherList: [], // 线上增值服务
      otherList2: [], // 线下增值服务
      otherList3: [],
      chooseOtherArr: [], // 选中的增值服务
      isAllChoose: [], // 是否全选
      orderInfo: null,
      isChange: false,
      middleInfo: null,
      otherTotalPrice: 0,
      onlineFile: null,
      offlineFile: null,
      ChooseCheck: false,
      join: false, //是否参加过
      fixedId: 0,
      gudingprice: 0,
      inputShow: false, //是否显示输入框
      remark: "",

      fixedCostList: [], // 固定费用列表
      fixedpriceAdd: 0, // 固定费用全部相加
      onlineOfflineCostList: [], // 线上 线下费用列表
      componentKey: 1,
    };
  },
  components: {},
  computed: {
    exhibitionId() {
      return this.$route.query.id;
    },
    applyCompanyId() {
      return this.$route.query.applyCompanyId;
    },
    applyCompanyOrderId() {
      return this.$route.query.applyCompanyOrderId;
    },
    groupId() {
      return this.$route.query.groupId;
    },
  },

  created() {
    this.init();
    this.getCost_Fixed();
    this.getCost_onlineOffline();
  },

  methods: {
    ...mapActions({
      getApplyFlow: "getApplyFlow",
      getApplyFlowSpeed: "getApplyFlowSpeed",
      getDePjNameGroup: "getDePjNameGroup",
      addApplyOrder: "addApplyOrder",
      getOrderDetail: "getOrderDetail",
      editApplyOrder: "editApplyOrder",
      getDeTerm: "getDeTerm",
      getGroupInfoById: "getGroupInfoById",
      getFile: "getFile",
      getjoin: "getjoin",

      getAllArea: "getAllArea", //获取展区列表
      getCommodities: "getCommodities", //获取商品信息
    }),
    async init() {
      console.log(this.chooseOtherArr, " this.chooseOtherArr12312312");
      this.chooseOtherArr = Array.from(new Set(this.chooseOtherArr));
      console.log(this.chooseOtherArr, " this.chooseOtherArr.");
      let opt = {
        ExhibitionId: this.exhibitionId,
        ApplyCompanyId: this.applyCompanyId,
      };
      let data = await this.getjoin(opt); //获取是否参加过上一届展会
      if (data.successed) {
        // this.join = data.info;
        //this.join=true
      }
      // 流程
      let taskList = await this.getApplyFlow();
      this.taskList = taskList;
      let info = await this.getApplyFlowSpeed(this.applyCompanyId);
      if (info && info.info) {
        this.speenInfo = info.info;
        if (this.taskList && this.taskList.length > 0) {
          this.taskList.map((c) => {
            if (this.speenInfo && this.speenInfo.speed >= c.speed) {
              c.process = true;
            }
          });
        }
      }
      // this.speenInfo不存在，即此轮流程已结束
      if (!this.speenInfo) {
        if (this.applyCompanyOrderId) {
          this.$router.push(
            "/join/basic?applyCompanyId=" +
              this.applyCompanyId +
              "&applyCompanyOrderId=" +
              this.applyCompanyOrderId
          );
        } else {
          this.$router.push(
            "/join/basic?applyCompanyId=" + this.applyCompanyId
          );
        }
      }

      // 展会下载文件
      let onlineFile = await this.getFile({
        ExhibitionId: this.exhibitionId,
        Name: "线上市场增值服务详情文件",
      });
      if (onlineFile) {
        this.onlineFile = onlineFile;
      }
      let offlineFile = await this.getFile({
        ExhibitionId: this.exhibitionId,
        Name: "线下市场增值服务详情文件",
      });
      if (offlineFile) {
        this.offlineFile = offlineFile;
      }

      // 订单信息
      let orderInfo = await this.getOrderDetail(this.applyCompanyOrderId);
      if (orderInfo && orderInfo.applyFileLink) {
        this.$router.replace("/join/finish");
      }
      this.orderInfo = orderInfo;

      console.log("订单信息：", this.orderInfo);
      if (this.orderInfo.isAgent === "是") {
        // 组团
        let deTerm = await this.getGroupInfoById(this.groupId);
        if (deTerm && deTerm.length) {
          if (deTerm[0].dePjNameList.length > 0) {
            this.boothList = deTerm[0].dePjNameList;
            if (this.boothList.length > 0) {
              this.boothList.map((c) => {
                c.width1 = 0;
                c.width2 = 0;
              });
            }
            this.selectedExhall = deTerm[0];
          }
          this.list = deTerm;
        }
      } else {
        // 展位、增值服务
        let lists = await this.getAllArea(this.exhibitionId);
        //   过滤出来中文和显示且必选的
        lists = lists.filter((c) => {
          return c.languageType === "中文" && c.isEnable;
        });

        //   this.getAllCommodities(lists[0].id) //   获取商品信息
        //   this.selectedExhall = lists[0];
        //   this.list = lists;
        //   console.log(this.list, '获取展区列表');

        // let lists = await this.getDePjNameGroup({
        //   "IsBoothGroup": "是",
        //   "typeLanguage": "中文",
        //   "ExhibitionId": this.exhibitionId
        // }); // 是：展区选择展位； 否：增值服务项目
        // console.log(lists, '数组');
        // let list = lists.filter(c => {
        //   return c.netShow === '显示'
        // });
        // if (list && list.length) {
        //   if (list[0].dePjNameList.length > 0) {
        //     this.boothList = list[0].dePjNameList;
        //     if (this.boothList.length > 0) {
        //       this.boothList.map(c => {
        //         c.width1 = 0;
        //         c.width2 = 0;
        //       })
        //     }
        //     this.selectedExhall = list[0];
        //   }
        // }

        let areaId = lists[0].id;
        if (this.orderInfo) {
          if (this.orderInfo.applyBoothOrderList.length > 0) {
            areaId = this.orderInfo.applyBoothOrderList[0].dePjNameGroupId;
          }
        }
        this.boothList = await this.getCommodities({
          exhibitionId: this.exhibitionId,
          areaId: areaId,
          isEnable: true,
        });
        this.boothList.map((c) => {
          c.width1 = 0;
          c.width2 = 0;
        });
        // this.selectedExhall = lists[0]; //默认选中第一个展区

        //如果有订单默认选中
        if (
          this.orderInfo &&
          this.orderInfo.applyBoothOrderList.length &&
          lists
        ) {
          lists.forEach((c) => {
            if (c.id == this.orderInfo.applyBoothOrderList[0].dePjNameGroupId) {
              this.selectedExhall = c;
              console.log(this.selectedExhall, "这个是选中的数据");
              //   if (this.selectedExhall.name.indexOf('其他') != -1) {
              //       this.inputShow = true
              //       this.remark = orderInfo.remark
              //   }
            }

            this.boothList.map((c) => {
              if (
                this.orderInfo &&
                this.orderInfo.applyBoothOrderList.length &&
                lists
              ) {
                if (c.name == this.orderInfo.applyBoothOrderList[0].name) {
                  //   this.boothList = c.dePjNameLis
                  this.chooseBooth = c;
                  if (this.chooseBooth) {
                    this.chooseBooth.width1 =
                      this.orderInfo.applyBoothOrderList[0].width;
                    this.chooseBooth.width2 =
                      this.orderInfo.applyBoothOrderList[0].height;
                  }
                }
              }
            });

            //   线上/线下 市场增值服务项目回显
          });

          if (
            this.orderInfo &&
            this.orderInfo.applyOtherOrderList.length &&
            lists
          ) {
            this.onlineOfflineCostList.map((v) => {
              this.orderInfo.applyOtherOrderList.map((b) => {
                if (v.name == b.name && b.dePjNameGroupName !== "固定费用") {
                  console.log(b, 1111111111);
                  v.orderNum = b.quantity;
                  v.isCheck = true;
                  v.isPack = true;

                  this.otherTotalPrice += b.totalPrice;
                  this.chooseOtherArr.push(v);
                  this.currency = v.monetaryUnit;

                  console.log(this.chooseOtherArr, 2222);
                }
              });
            });
          }
        }

        this.list = lists;
        console.log(this.list, "this.list");
        console.log(this.boothList, "12222223");
      }
      console.log(this.otherList2, "this.otherList2");
      //   }
    },
    goBack() {
      this.$router.push(
        "/join/entrance?applyCompanyId=" +
          this.applyCompanyId +
          "&applyCompanyOrderId=" +
          this.applyCompanyOrderId
      );
    },
    async goNext() { 
      if(!this.selectedExhall){
            this.$Message.warning("请选择您要参展的展区");
          return;
      }
      // 保存前同时确认展区 ID 和名称，避免提交不完整的展区信息。
      if(!this.selectedExhall.id || !this.selectedExhall.name){
            this.$Message.warning("请选择您要参展的展区");
          return;
      }
      if (this.orderInfo.isAgent === "否") {
        if (!this.chooseBooth) {
          this.$Message.warning("请选择展位类型");
          return;
        }
        if (!this.chooseBooth.width1 || !this.chooseBooth.width2) {
          this.$Message.warning("请输入展位宽度");
          return;
        }
      }
      if (this.orderInfo.isAgent === "是") {
        if (!this.chooseBooth) {
          this.$Message.warning("请选择组团类型");
          return;
        }
        if (!this.chooseBooth.width1 || !this.chooseBooth.width2) {
          this.$Message.warning("请输入组团宽度");
          return;
        }
      }

      let ApplyOtherOrderList = [];

      if (this.fixedCostList && this.fixedCostList.length > 0) {
        this.fixedCostList.map((c) => {
          if (c.groupLanguage == "中文" && c.isEnable) {
            ApplyOtherOrderList.push({
              ApplyCompanyOrderId: this.applyCompanyOrderId,
              DePjNameGroupId: c.dePjNameGroupId,
              DePjNameGroupName: c.groupType,
              ThirdPartyCommodityId: c.id,
              Name: c.name,
              Quantity: 1, //填的数量
              Unit: c.unit,
              UnitPrice: c.price,
              TotalPrice: c.price,
              MonetaryUnit: c.currencyKind,
              DurationType: "",
              DurationBegin: moment(new Date()).format("YYYY-MM-DD"),
              DurationEnd: moment(new Date()).format("YYYY-MM-DD"),
              Rex: 1,
              RexMoney: c.price,
              GpName: "",
              GpCode: "",
              GroupId: 1,
              PjCode: "",
              PjFormat: "",
            });
          }
        });
      }
      if (this.onlineOfflineCostList && this.onlineOfflineCostList.length > 0) {
        this.onlineOfflineCostList.map((c) => {
          if (c.isCheck && c.groupLanguage == "中文") {
            ApplyOtherOrderList.push({
              ApplyCompanyOrderId: this.applyCompanyOrderId,
              DePjNameGroupId: c.dePjNameGroupId,
              DePjNameGroupName: c.groupType,
              ThirdPartyCommodityId: c.id,
              Name: c.name,
              Quantity: c.orderNum ? c.orderNum : 0, //填的数量
              Unit: c.unit,
              UnitPrice: c.price,
              TotalPrice: c.orderNum ? c.price * c.orderNum : 0,
              MonetaryUnit: c.currencyKind,
              DurationType: "",
              DurationBegin: moment(new Date()).format("YYYY-MM-DD"),
              DurationEnd: moment(new Date()).format("YYYY-MM-DD"),
              Rex: 1,
              RexMoney: c.orderNum ? c.price * c.orderNum : 0,
              GpName: c.kindName,
              GpCode: "",
              GroupId: 1,
              PjCode: "",
              PjFormat: "",
            });
          }
        });
      }

      let req = {};

      req = {
        Id: this.applyCompanyOrderId,
        ApplyCompanyId: this.applyCompanyId,
        ExhibitionId: this.exhibitionId,
        IsAgent: "否",
        Remark: "",
        ApplyBoothOrderList: [
          {
            ApplyCompanyOrderId: this.applyCompanyOrderId,
            DePjNameGroupId: this.selectedExhall.id,
            DePjNameGroupName: this.selectedExhall.name,
            ThirdPartyCommodityId: this.chooseBooth.id,
            Name: this.chooseBooth.name,
            Width: this.chooseBooth.width1,
            Height: this.chooseBooth.width2,
            Area: this.chooseBooth.width1 * this.chooseBooth.width2,
            Unit: this.chooseBooth.unit,
            UnitPrice: this.chooseBooth.price,
            TotalPrice:
              this.chooseBooth.width1 *
              this.chooseBooth.width2 *
              this.chooseBooth.price,
            MonetaryUnit: this.chooseBooth.currencyKind,
            IsAgent: "否",
            Rex: 1,
            RexMoney:
              this.chooseBooth.width1 *
              this.chooseBooth.width2 *
              this.chooseBooth.price,
            GpName: this.chooseBooth.kindName,
            GpCode: "",
            GroupId: 1,
            PjCode: "",
            PjFormat: "",
            BoothType: this.chooseBooth.boothKind || "",
          },
        ],
        ApplyOtherOrderList: ApplyOtherOrderList,
      };

      if (this.chooseBooth.boothArea > 1) {
        req.ApplyBoothOrderList[0].TotalPrice = (
          (this.chooseBooth.width1 *
            this.chooseBooth.width2 *
            this.chooseBooth.price) /
          parseInt(this.chooseBooth.boothArea)
        ).toFixed();

        req.ApplyBoothOrderList[0].RexMoney = (
          (this.chooseBooth.width1 *
            this.chooseBooth.width2 *
            this.chooseBooth.price) /
          parseInt(this.chooseBooth.boothArea)
        ).toFixed();
      }

      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);

      if (this.speenInfo.speed < 3) {
        console.log(this.inputShow, this.remark, "哈哈哈");
        if (this.inputShow && !this.remark) {
          this.$Message.warning("请输入产品类型");
          return;
        }
        let info = await this.addApplyOrder(req);
        this.loading = false;
        if (info && info.successed) {
          this.$Message.success("保存成功！");
          if (this.groupId) {
            this.$router.push(
              "/join/catalogue?id=" +
                this.exhibitionId +
                "&applyCompanyId=" +
                this.applyCompanyId +
                "&applyCompanyOrderId=" +
                this.applyCompanyOrderId +
                "&groupId=" +
                this.groupId
            );
          } else {
            this.$router.push(
              "/join/catalogue?id=" +
                this.exhibitionId +
                "&applyCompanyId=" +
                this.applyCompanyId +
                "&applyCompanyOrderId=" +
                this.applyCompanyOrderId
            );
          }
        } else {
          this.msgErrors = info.errors[0].description;
          this.errorMsgBool = true;
        }
      } else {
        console.log(this.inputShow, this.remark, "哈哈哈");
        if (this.inputShow && !this.remark) {
          this.$Message.warning("请输入产品类型");
          return;
        }
        console.log(req, "0000000000");
        let info = await this.editApplyOrder(req);
        console.log(info, "info");
        //let info = await this.editApplyOrder({...{Id: this.orderInfo.id}, ...req});
        this.loading = false;

        if (info && info.successed) {
          this.$Message.success("修改成功！");
          if (this.groupId) {
            this.$router.push(
              "/join/catalogue?id=" +
                this.exhibitionId +
                "&applyCompanyId=" +
                this.applyCompanyId +
                "&applyCompanyOrderId=" +
                this.applyCompanyOrderId +
                "&groupId=" +
                this.groupId
            );
          } else {
            this.$router.push(
              "/join/catalogue?id=" +
                this.exhibitionId +
                "&applyCompanyId=" +
                this.applyCompanyId +
                "&applyCompanyOrderId=" +
                this.applyCompanyOrderId
            );
          }
        } else {
          this.msgErrors = info.errors[0].description;
          this.errorMsgBool = true;
        }
      }
    },

    // 2127-12-27
    async getCost_Fixed(id) {
      this.fixedpriceAdd = 0;
      this.fixedCostList = await this.getCommodities({
        exhibitionId: this.exhibitionId,
        isEnable: true,
        groupType: ["固定费用"],
      });

      this.fixedCostList.map((c) => {
        console.log(c, 11111);
        if (c.groupLanguage === "中文" && c.isEnable) {
          this.fixedpriceAdd += c.price;
        }
      });

      console.log(this.fixedCostList, "获取的固定费用");
    },

    async getCost_onlineOffline(id) {
      this.onlineOfflineCostList = await this.getCommodities({
        exhibitionId: this.exhibitionId,
        isEnable: true,
        groupType: ["线上", "线下"],
      });
      this.onlineOfflineCostList.map((c) => {
        c.isPack = false;
        c.isCheck = false;
        c.orderNum = 0;
      });
      console.log(this.onlineOfflineCostList, "获取的线上/下费用");
    },

    // 重复利用的接口
    async getAllCommodities(id) {
      this.boothList = await this.getCommodities({
        exhibitionId: this.exhibitionId,
        areaId: id,
        isEnable: true,
        //   groupType: ['固定费用', '线上','线下']
      });
      this.boothList.map((c) => {
        c.width1 = 0;
        c.width2 = 0;
      });
      console.log(this.listCommodities, "获取的商品信息");
    },

    async select(e) {
      this.chooseBooth = null;
      console.log(e, "选中的展区");
      // if (this.chooseBooth) {
      //     this.isChange = true;
      //     return
      // }
      this.selectedExhall = e;
      this.getAllCommodities(e.id); //   获取商品信息

      //   if (e.name.indexOf('其他') !== -1) {
      //     this.inputShow = true
      //   }
      //   else {
      //     this.inputShow = false
      //   }
      //   if (this.chooseBooth) {
      //     this.isChange = true;
      //     this.middleInfo = e;

      //   } else {
      //     this.selectedExhall = e;
      //     if (e.dePjNameList.length > 0) {
      //       e.dePjNameList.map(c => {
      //         c.width1 = 0;
      //         c.width2 = 0;
      //       })
      //     }
      //     this.boothList = e.dePjNameList;
      //     this.chooseBooth = null;
      //     console.log(this.selectedExhall, 1111111111)
      //   }
    },
    changeNumber(item, e) {
      this.otherTotalPrice = 0;
      this.chooseOtherArr.map((c) => {
        if (c.orderNum && c.price && c.isPack) {
          this.otherTotalPrice += c.orderNum * c.price;
        } else {
          this.otherTotalPrice = this.otherTotalPrice;
        }
      });
    },
    confirm() {
      this.isChange = false;
      this.getAllCommodities(this.selectedExhall.id);
      //   this.selectedExhall = this.middleInfo;
      //   if (this.middleInfo.dePjNameList.length > 0) {
      //     this.middleInfo.dePjNameList.map(c => {
      //       c.width1 = 0;
      //       c.width2 = 0;
      //     })
      //   }
      //   this.boothList = this.middleInfo.dePjNameList;
      //   this.chooseBooth = null;
    },
    choose(e) {
      this.chooseBooth = e;
      console.log(e, "eeeeeeeeeee");
    },
    changeWidth1(e, i) {
      this.$set(this.boothList, i, this.boothList[i]);
    },
    changeWidth2(e, i) {
      this.$set(this.boothList, i, this.boothList[i]);
    },

    allChoose(e, value) {
      // console.log(this.isAllChoose, 'eeeeeeeee')
      console.log(this.chooseOtherArr, "666666");
      if (value) {
        e.isPack = true;
      } else {
        e.isPack = false;
      }
      this.componentKey++;

      const exists = this.chooseOtherArr.some((item) => item.id === e.id);
      if (exists) {
        this.chooseOtherArr.forEach((element, index) => {
          if (element.id == e.id) {
            this.chooseOtherArr.splice(index, 1);
          }
        });
      } else {
        this.chooseOtherArr.push(e);
      }
      this.otherTotalPrice = 0;
      if (
        this.chooseOtherArr &&
        this.chooseOtherArr.length > 0 &&
        e.type != "固定费用"
      ) {
        this.chooseOtherArr.map((c) => {
          if (c.orderNum && c.price && c.isPack) {
            this.otherTotalPrice += c.orderNum * c.price;
          }
        });
      } else if (
        this.chooseOtherArr &&
        this.chooseOtherArr.length > 0 &&
        e.type == "固定费用"
      ) {
        //this.otherTotalPrice =this.gudingprice
      } else {
        this.otherTotalPrice = 0;
      }
    },
    chooseOne(e, index) {
      // 如果为true，则为选中，否则为取消选中
      if (e.isCheck) {
        this.onlineOfflineCostList[index].isCheck = false;
      } else {
        this.onlineOfflineCostList[index].isCheck = true;
      }

      this.componentKey++;

      const exists = this.chooseOtherArr.some((item) => item.id === e.id);
      if (exists) {
        this.chooseOtherArr.forEach((element, index) => {
          if (element.id == e.id) {
            this.chooseOtherArr.splice(index, 1);
          }
        });
      } else {
        this.chooseOtherArr.push(e);
      }
      this.otherTotalPrice = 0;
      console.log(this.chooseOtherArr, 22222222);
      if (this.chooseOtherArr && this.chooseOtherArr.length > 0) {
        this.chooseOtherArr.map((c) => {
          if (c.orderNum && c.price && c.isPack) {
            this.otherTotalPrice += c.orderNum * c.price;
          } else {
            this.otherTotalPrice = this.otherTotalPrice;
          }
        });
        //this.otherTotalPrice=this.otherTotalPrice+this.gudingprice
      } else {
        this.otherTotalPrice = 0;
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.order {
  &-task {
    width: 100%;
    margin: 20px 0 50px;
    padding: 0 80px;
    display: flex;
    justify-content: space-between;
    color: #666;
    position: relative;

    .task-one {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 2;

      .box {
        width: 20px;
        height: 20px;
        background-color: #fff;
        box-shadow: 0px 2px 5px 0px #00bdca59;
        border-radius: 50%;
        margin-top: 10px;

        div {
          width: 14px;
          height: 14px;
          background-color: #8ba5bc;
          border-radius: 50%;
          margin: 3px auto 0;
        }
      }
    }

    .line {
      height: 8px;
      background-color: #d7e2e4;
      position: absolute;
      width: 998px;
      left: 108px;
      top: 37px;
      z-index: 1;
    }

    .ing {
      color: #00bdca;

      .box {
        div {
          background-color: #00bdca;
        }
      }
    }

    .finished {
      color: #00bdca;

      .box {
        background-color: #00bdca;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-color: #00bdca;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 64px;
      font-size: 20px;
    }

    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-exhall {
    padding: 30px 30px 0 30px;
    background-color: #fff;

    .exhall-header {
      width: 100%;
      height: 46px;
      background-color: #e5f8fa;
      color: #333;
      font-size: 18px;
      line-height: 46px;
      padding-left: 20px;
      font-weight: bold;
    }

    .exhall-list {
      display: flex;
      flex-wrap: wrap;
      padding: 20px 0 15px;
      background-color: #fff;

      .list-one {
        padding: 5px 20px 0px 20px;
        border: solid 1px #999;
        margin: 0 15px 15px 0;
        border-radius: 5px;
        cursor: pointer;
      }

      .selected {
        background-color: #db2a4b;
        border: solid 1px #db2a4b;
        color: #fff;
      }
    }

    .booth-list {
      background-color: #fff;
      padding: 20px 0 10px 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .booth-one {
        width: 560px;
        height: 230px;
        background-color: #f5f5f5;
        margin-bottom: 20px;
        padding: 20px;
        position: relative;
        cursor: pointer;

        .f {
          display: flex;
          justify-content: space-between;

          p {
            width: 90%;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            font-size: 20px;
            color: #333;
          }

          p:last-child {
            text-align: right;
            font-size: 14px;
          }
        }

        .s {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          p {
            width: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            color: #333;
          }

          p:last-child {
            text-align: right;
            font-size: 24px;
            color: #db2a4b;
          }
        }

        .t {
          margin-top: 10px;
          color: #333;
        }

        .l {
          color: #333;
          font-size: 16px;
          margin-top: 30px;
        }

        .choose {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 0;
          height: 0;
          border-bottom: 46px solid #d9d9d9;
          border-left: 46px solid transparent;

          i {
            position: absolute;
            top: 10px;
            left: -30px;
            color: #fff;
            font-size: 30px;
          }
        }

        .choosed {
          border-bottom: 46px solid #db2a4b;
        }
      }

      .chooseboothOne {
        border: 1px solid red;
      }
    }
  }

  &-other {
    background-color: #fff;
    padding: 0 30px 30px;

    .other-header {
      width: 100%;
      height: 46px;
      background-color: #e5f8fa;
      color: #333;
      font-size: 18px;
      line-height: 46px;
      padding-left: 20px;
      font-weight: bold;
    }

    .other-online {
      padding: 0 30px;
      margin-bottom: 30px;
      font-size: 16px;

      a {
        text-decoration: underline;
      }
    }

    .other-list {
      width: 1080px;
      margin: 0 auto 30px;
      border: solid 1px #e5e5e5;

      .top {
        background-color: #f5f5f5;
        height: 46px;
        line-height: 46px;
        position: relative;
        padding: 0 20px;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333;
        border-bottom: 1px solid #e5e5e5;

        .r {
          cursor: pointer;
          display: flex;
          align-items: center;

          i {
            font-size: 20px;
            margin-left: 5px;
          }
        }
      }

      .content {
        padding: 20px 20px 0 20px;

        .content-one {
          width: 100%;
          margin: 0 auto 20px;
          border: 1px solid #e5e5e5;

          .title {
            width: 100%;
            height: 46px;
            background-color: #f5f5f5;
            line-height: 46px;
            font-size: 16px;
            color: #333;
            padding-left: 20px;
            border-bottom: 1px solid #e5e5e5;
          }

          .details {
            width: 100%;
            height: 230px;
            display: flex;

            .text {
              width: 50%;
              height: 100%;
              padding: 0 30px;
              position: relative;
              cursor: pointer;
              color: #333;
              font-size: 16px;

              .time {
                width: 100%;
                display: flex;
                align-items: center;
                margin-top: 20px;

                span {
                  width: 100px;
                }
              }

              .choose {
                position: absolute;
                right: 0;
                bottom: 0;
                width: 0;
                height: 0;
                border-bottom: 46px solid #d9d9d9;
                border-left: 46px solid transparent;

                i {
                  position: absolute;
                  top: 10px;
                  left: -30px;
                  color: #fff;
                  font-size: 30px;
                }
              }

              .choosed {
                border-bottom: 46px solid #db2a4b;
              }
            }

            img {
              width: 50%;
              height: 100%;
            }
          }
        }
      }
    }

    .total {
      width: 100%;
      height: 173px;
      background-color: #f5f5f5;
      border: solid 1px #e5e5e5;
      text-align: right;
      font-size: 16px;
      color: #333;
      padding: 30px;

      p {
        line-height: 1;
      }

      span {
        color: #db2a4b;
      }
    }
  }

  &-btn {
    margin-top: 50px;
    margin-bottom: 80px;
    text-align: center;

    button {
      width: 200px;
      height: 48px;
      background-color: #024c8b;
      font-size: 16px;
      border-color: #024c8b;
    }
  }
}

.change-modal {
  padding: 6px 16px 8px;

  &-top {
    display: flex;
    align-items: center;

    p {
      padding-left: 12px;
      color: #17233d;
      font-size: 16px;
      line-height: 42px;
    }
  }

  &-bottom {
    margin-left: 40px;
  }

  &-btn {
    text-align: right;
    margin-top: 20px;
  }
}
</style>
